module.exports = __webpack_public_path__ + "static/media/achieve11.f1f8c57b.jpg";